import { connect } from "react-redux";
import AppraiserList from "containers/Appraiser/AppraiserList";
import { getAppraiserList, } from "actions/appraiser";

const mapStateToProps = (state) => {
  return {
    isFetchingAppraiserList: state.appraiser.fetchingAppraiserList,
    appraiserList: state.appraiser.appraiserList,
    profile: state.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAppraiserList(search) {
    dispatch(getAppraiserList(true, search));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AppraiserList);
